// src/components/shipment/SortDropdown.jsx
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, ChevronDown } from 'lucide-react';

const sortOptions = [
    { value: 'ID_DESC', label: 'Most Recent' },
    { value: 'ID_ASC', label: 'Oldest First' },
    { value: 'CUSTOMER_ASC', label: 'Customer A-Z' },
    { value: 'CUSTOMER_DESC', label: 'Customer Z-A' },
    { value: 'CARRIER_ASC', label: 'Carrier' },
];

const SortDropdown = ({ sortBy, setSortBy, isOpen, setIsOpen }) => {
    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-2 px-4 py-2 bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 rounded-lg text-sm font-medium hover:bg-slate-200 dark:hover:bg-slate-600 transition-colors"
            >
                {sortOptions.find(opt => opt.value === sortBy)?.label || 'Most Recent'}
                <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
            </button>

            <AnimatePresence>
                {isOpen && (
                    <>
                        <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} />
                        <motion.div
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 10 }}
                            className="absolute top-full right-0 mt-2 w-48 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-200 dark:border-slate-700 z-50 overflow-hidden"
                        >
                            {sortOptions.map((option) => (
                                <button
                                    key={option.value}
                                    onClick={() => { setSortBy(option.value); setIsOpen(false); }}
                                    className={`w-full px-4 py-2.5 text-left text-sm transition-colors flex items-center justify-between ${sortBy === option.value
                                        ? 'bg-blue-50 dark:bg-blue-500/10 text-blue-600 dark:text-blue-400 font-medium'
                                        : 'text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700'
                                        }`}
                                >
                                    {option.label}
                                    {sortBy === option.value && <CheckCircle className="w-4 h-4" />}
                                </button>
                            ))}
                        </motion.div>
                    </>
                )}
            </AnimatePresence>
        </div>
    );
};

export default SortDropdown;